import { MeasurementSlotPicker } from '../MeasurementSlotPicker';

type FieldProps = {
  city: string;
  preferredTime: string;
  notes: string;
  onCity: (v: string) => void;
  onPreferredTime: (v: string) => void;
  onNotes: (v: string) => void;
  disabled?: boolean;
  onHaptic?: () => void;
};

/** Поля заявки на замер: адрес, слот, комментарий для замерщика. */
export function AdminMeasurementIntakeFields({
  city,
  preferredTime,
  notes,
  onCity,
  onPreferredTime,
  onNotes,
  disabled,
  onHaptic,
}: FieldProps) {
  return (
    <div className="space-y-2">
      <label className="block">
        <span className="text-[10px] font-bold uppercase tracking-wide" style={{ color: 'var(--cyan)' }}>
          Адрес объекта
        </span>
        <input
          className="input-glass w-full text-sm min-h-[44px] mt-1 touch-manipulation"
          placeholder="Москва, ул. Примерная, 12, подъезд 2"
          value={city}
          disabled={disabled}
          onChange={(e) => onCity(e.target.value)}
        />
      </label>
      <div className="block">
        <span className="text-[10px] font-bold uppercase tracking-wide" style={{ color: 'var(--text-3)' }}>
          Дата и интервал выезда
        </span>
        <div className="mt-1">
          <MeasurementSlotPicker
            value={preferredTime}
            onChange={onPreferredTime}
            disabled={disabled}
            onHaptic={onHaptic}
          />
        </div>
      </div>
      <label className="block">
        <span className="text-[10px] font-bold uppercase tracking-wide" style={{ color: '#B794F4' }}>
          Комментарий для замерщика
        </span>
        <textarea
          className="input-glass w-full text-sm min-h-[72px] mt-1 resize-none touch-manipulation"
          placeholder="Домофон, парковка, что смотреть, контакт на объекте…"
          value={notes}
          disabled={disabled}
          onChange={(e) => onNotes(e.target.value)}
        />
      </label>
    </div>
  );
}
